import api from "./axiosInstance";

export const getClients = async (limit, offset, filters) => {
  const params = {
    limit,
    offset,
  };

  // EVENT
  if (filters.event && filters.event !== "All") {
    params.event = filters.event;
  }

  // TICKETS
  if (filters.ticketsRange && filters.ticketsRange !== "All") {
    params.ticket_count = filters.ticketsRange;
  }

  // VIP / BACKSTAGE
  if (filters.vip && filters.vip !== "All") {
    const value = filters.vip === "Yes";
    params.is_vip = value;
    params.is_backstage = value;
  }

  // TABLE
  if (filters.table && filters.table !== "All") {
    params.is_table = filters.table === "Yes";
  }
  
  const res = await api.get("api/v1/clients/", { params });
  return res.data;
};

export const exportClients = async () => {
  const res = await api.get("api/v1/clients/export/");
  return res.data;
};

export const importClients = async (payload) => {
  const res = await api.post("api/v1/clients/import/", payload);
  return res.data;
};
